"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VestingClaimDialogForm = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_intl_1 = require("react-intl");
const mui_dialog_form_1 = require("@dzambalaorg/mui-dialog-form");
const mui_inputs_asset_1 = require("@dzambalaorg/mui-inputs-asset");
const types_1 = require("@framework/types");
const exchange_1 = require("@framework/exchange");
const ui_kit_1 = require("@dzambalaorg/ui-kit");
const validation_1 = require("./validation");
const parameters_input_1 = require("./parameters-input");
const types_2 = require("../../../../../../types");
const VestingClaimDialogForm = (props) => {
    const { selectedItem, open, mode, service, ...rest } = props;
    if (!open || !selectedItem) {
        return null;
    }
    const { id, parameters, item } = selectedItem;
    const fixedValues = {
        id,
        parameters,
        item,
    };
    return ((0, jsx_runtime_1.jsxs)(mui_dialog_form_1.FormDialog, { open: open, initialValues: fixedValues, validationSchema: validation_1.validationSchema, message: `dialogs.${mode}`, testId: "VestingClaimEditDialog", filter: ({ item, parameters }) => ({
            parameters: {
                externalId: "",
                owner: parameters.owner,
                monthlyRelease: parameters.monthlyRelease,
                cliffInMonth: parameters.cliffInMonth,
                startTimestamp: parameters.startTimestamp,
            },
            item: (0, exchange_1.cleanUpAsset)(item),
        }), ...rest, children: [(0, jsx_runtime_1.jsx)(parameters_input_1.VestingParametersInput, { prefix: "parameters" }), (0, jsx_runtime_1.jsx)(mui_inputs_asset_1.TemplateAssetInput, { autoSelect: true, multiple: true, prefix: "item", tokenType: {
                    disabledOptions: [types_1.TokenType.NATIVE, types_1.TokenType.ERC721, types_1.TokenType.ERC998, types_1.TokenType.ERC1155],
                }, contract: {
                    data: {
                        contractModule: [types_1.ModuleType.HIERARCHY],
                    },
                } }), service === types_2.ServiceType.ADMIN && ((0, jsx_runtime_1.jsx)(ui_kit_1.Alert, { severity: "warning", sx: { mt: 2 }, children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "alert.allowanceClaim" }) }))] }));
};
exports.VestingClaimDialogForm = VestingClaimDialogForm;
//# sourceMappingURL=index.js.map